/**
 * File: /Users/tomasmuniesa/Documents/develop/nousmedis/nm-apps/3_catalog_cloud/develop/frontend/src/app/modules/tms-tools/pipes/keep-order.pipe.ts
 * Project: /Users/tomasmuniesa/Documents/develop/nousmedis/nm-apps/3_catalog_cloud/develop/frontend
 * Created Date: Tuesday, October 22nd 2024, 10:45:51 am
 * Author: Tomás
 * -----
 * Last Modified:  Tuesday, 22nd October 2024 10:57:25 am
 * Modified By: Tomás (tomas@cege.es>)
 * -----
 * Copyright (c) 2024 Nousmedis, CeGe
 * ------------------------------------
 */


import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keepOrder'
})
export class KeepOrderPipe implements PipeTransform {
  transform(value: any): any {
    let dataToReturn = [];
    for (let [key, val] of Object.entries(value)) {
      dataToReturn.push(val);
    }
    return dataToReturn;  // Devuelve las entradas en su orden original
  }
}